import React, { useEffect, useState } from 'react';
const STORAGE_KEY = 'biologia-pronta-launch-deadline';
const DAY_IN_MS = 24 * 60 * 60 * 1000;
interface TimeLeft {
  hours: number;
  minutes: number;
  seconds: number;
}
export function AnnouncementBar() {
  const [timeLeft, setTimeLeft] = useState<TimeLeft>({
    hours: 24,
    minutes: 0,
    seconds: 0
  });
  useEffect(() => {
    const storedDeadline = Number(window.localStorage.getItem(STORAGE_KEY));
    let deadline = Number.isFinite(storedDeadline) && storedDeadline > Date.now() ? storedDeadline : Date.now() + DAY_IN_MS;
    window.localStorage.setItem(STORAGE_KEY, String(deadline));
    const updateTimer = () => {
      const now = Date.now();
      if (deadline <= now) {
        deadline = now + DAY_IN_MS;
        window.localStorage.setItem(STORAGE_KEY, String(deadline));
      }
      const totalSeconds = Math.max(0, Math.ceil((deadline - now) / 1000));
      setTimeLeft({
        hours: Math.floor(totalSeconds / 3600),
        minutes: Math.floor(totalSeconds % 3600 / 60),
        seconds: totalSeconds % 60
      });
    };
    updateTimer();
    const interval = window.setInterval(updateTimer, 1000);
    return () => window.clearInterval(interval);
  }, []);
  return <aside className="flex h-8 w-full items-center justify-center bg-brand-deep px-2 text-white shadow-sm" data-id="element-16" data-mp="3sgi3loiz98uw">
      <div className="flex items-center gap-2 sm:gap-3" data-id="element-17" data-mp="19ym5qimyknm">
        <p className="whitespace-nowrap text-[9px] font-extrabold tracking-wide sm:text-[10px]" data-id="element-18" data-mp="oyzyhoulafy6">
          ⚡ L’OFFERTA DI LANCIO SCADE TRA:
        </p>
        <div className="flex items-center gap-1 font-mono" aria-label={`${timeLeft.hours} ore, ${timeLeft.minutes} minuti, ${timeLeft.seconds} secondi rimanenti`} data-id="element-19" data-mp="txbaa54g30j1">
          <TimerUnit value={timeLeft.hours} label="ORE" data-id="element-20" data-mp="k6gkiqrzpisu" />
          <span className="text-xs font-bold" data-id="element-21" data-mp="17x3uripdokik">:</span>
          <TimerUnit value={timeLeft.minutes} label="MIN" data-id="element-22" data-mp="17waxr9g819dm" />
          <span className="text-xs font-bold" data-id="element-23" data-mp="1colts17ucb0w">:</span>
          <TimerUnit value={timeLeft.seconds} label="SEC" data-id="element-24" data-mp="1cq5dk1sph47f" />
        </div>
      </div>
    </aside>;
}
function TimerUnit({
  value,
  label
}: {
  value: number;
  label: string;
}) {
  return <span className="whitespace-nowrap text-[11px] font-extrabold sm:text-xs" data-id="element-25" data-mp="1hm14ox6gjnnx">
      {String(value).padStart(2, '0')}
      <span className="ml-0.5 text-[8px] font-bold text-white/70" data-id="element-26" data-mp="1cnzg5wq9iw52">{label}</span>
    </span>;
}